/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Row_Clickup_NoteInputs */

const en_mk_calc_row_clickup_note = /** @type {(inputs: Mk_Calc_Row_Clickup_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$12 + US$28 per seat. The AI add-on is charged for every paid member, including the ones who never touch AI.`)
};

const id_mk_calc_row_clickup_note = /** @type {(inputs: Mk_Calc_Row_Clickup_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$12 + US$28 per kursi. Add-on AI dikenakan ke semua anggota berbayar, termasuk yang tidak memakai AI.`)
};

/**
* | output |
* | --- |
* | "US$12 + US$28 per seat. The AI add-on is charged for every paid member, including the ones who never touch AI." |
*
* @param {Mk_Calc_Row_Clickup_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_row_clickup_note = /** @type {((inputs?: Mk_Calc_Row_Clickup_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Row_Clickup_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_row_clickup_note(inputs)
	return en_mk_calc_row_clickup_note(inputs)
});